import { differenceInCalendarDays, isSameMonth } from 'date-fns'
import { toDate } from '@/features/shared/format'

export const DATE_BUCKETS = ['today', 'yesterday', 'week', 'month', 'older'] as const
export type DateBucket = (typeof DATE_BUCKETS)[number]

/** Listeyi tarih başlıklarına bölmek için: bugün, dün, son 7 gün, bu ay, daha eski. */
export function dateBucket(value: string, now: Date): DateBucket {
  // API `DD.MM.YYYY HH:mm:ss` gönderir; parseISO bunu çözemez.
  const d = toDate(value)
  if (!d) return 'older'
  const diff = differenceInCalendarDays(now, d)
  if (diff <= 0) return 'today'
  if (diff === 1) return 'yesterday'
  if (diff < 7) return 'week'
  if (isSameMonth(d, now)) return 'month'
  return 'older'
}

/** Sıralı listeyi sırayı bozmadan ardışık tarih gruplarına ayırır. */
export function groupByDate<T extends { created_at: string }>(items: T[], now: Date): { bucket: DateBucket; items: T[] }[] {
  const out: { bucket: DateBucket; items: T[] }[] = []
  for (const it of items) {
    const b = dateBucket(it.created_at, now)
    const last = out.at(-1)
    if (last && last.bucket === b) last.items.push(it)
    else out.push({ bucket: b, items: [it] })
  }
  return out
}
